module.exports = __webpack_public_path__ + "static/4-176e716afee1107dc575d6f99d45bb5e.png";